export function ConnectGuideLinux() {
  return (
    <svg viewBox="0 0 240 220" xmlns="http://www.w3.org/2000/svg" className="w-full max-w-xs mx-auto block" aria-hidden="true">
      {/* Desktop */}
      <rect width="240" height="220" fill="#2c3e50" />
      {/* Top bar (Ubuntu-style) */}
      <rect width="240" height="22" fill="#3d3d3d" />
      {/* Activities label */}
      <text x="12" y="15" fontSize="10" fill="#e0e0e0">Aktivitäten</text>
      {/* Right side icons */}
      <text x="200" y="15" fontSize="10" fill="#e0e0e0">◈</text>
      <text x="216" y="15" fontSize="9" fill="#aaa">9:41</text>
      {/* Network panel */}
      <rect x="156" y="22" width="82" height="155" rx="6" fill="#404040" stroke="#555" strokeWidth="0.8" />
      {/* WiFi section header */}
      <text x="197" y="42" textAnchor="middle" fontSize="10" fontWeight="600" fill="#fff">WLAN</text>
      <rect x="167" y="46" width="60" height="14" rx="7" fill="#e0e0e0" opacity="0.15" />
      <text x="197" y="56" textAnchor="middle" fontSize="9" fill="#ccc">Eingeschaltet</text>
      <line x1="162" y1="65" x2="232" y2="65" stroke="#555" strokeWidth="0.5" />
      {/* Connected network – highlighted */}
      <rect x="162" y="68" width="70" height="34" rx="4" fill="#4a4a4a" />
      <rect x="166" y="78" width="3" height="5" rx="1" fill="#a8c7fa" />
      <rect x="171" y="74" width="3" height="9" rx="1" fill="#a8c7fa" />
      <rect x="176" y="70" width="3" height="13" rx="1" fill="#a8c7fa" />
      <text x="183" y="80" fontSize="9.5" fill="#fff" fontWeight="500">Dein-WLAN</text>
      <text x="183" y="92" fontSize="8" fill="#aaa">Verbunden</text>
      <line x1="162" y1="106" x2="232" y2="106" stroke="#555" strokeWidth="0.3" />
      {/* Other networks */}
      <rect x="162" y="110" width="70" height="30" rx="4" fill="transparent" />
      <rect x="166" y="118" width="3" height="5" rx="1" fill="#777" />
      <rect x="171" y="115" width="3" height="8" rx="1" fill="#999" />
      <rect x="176" y="111" width="3" height="12" rx="1" fill="#bbb" />
      <text x="183" y="126" fontSize="9" fill="#aaa">Gäste-WLAN</text>
      <line x1="162" y1="144" x2="232" y2="144" stroke="#555" strokeWidth="0.3" />
      {/* Settings */}
      <text x="197" y="163" textAnchor="middle" fontSize="8.5" fill="#a8c7fa">Einstellungen…</text>
      {/* Arrow from top bar icon to panel */}
      <polygon points="210,22 205,12 215,12" fill="#ff9500" />
    </svg>
  );
}
